import React, { useState } from 'react';

import { colors } from '@styleseat/brand';

import NotificationBanner from '../NotificationBanner';
import { CardAuthorizationModal } from '../../appointment/CardAuthorizationModal';

type ClientCardAuthSuccessNotificationProps = {
  notification: {
    client_name: string,
    auth_amount: string,
  }
};

export default function ClientCardAuthSuccessNotification(
  props: ClientCardAuthSuccessNotificationProps,
) {
  const [isModalOpen, setModalOpen] = useState(false);

  const handleButtonClick = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

  const { notification } = props;

  const buttonProps = {
    text: 'Learn More',
    onClick: handleButtonClick,
    clickTracking: {},
    appearance: 'text-light',
    size: 'small',
  };

  const highlightedText = `${notification.client_name} has sufficient funds`;
  const clientNameSuffix = notification.client_name.endsWith('s') ? "'" : "'s";
  const subTextName = `${notification.client_name}${clientNameSuffix}`;
  const auth_amount = Number(notification.auth_amount).toFixed(2);
  const subText = `${subTextName} card was temporarily charged. We're holding $${auth_amount} to ensure it covers the appointment cost plus tip.`;

  return (
    <React.Fragment>
      <NotificationBanner
        notification={notification}
        iconSize={36}
        highlightedText={highlightedText}
        subText={subText}
        highlightBorderColor={colors.green}
        buttonProps={buttonProps}
        showAvatarIcon
      />
      {isModalOpen && (<CardAuthorizationModal onBackdropClick={handleModalClose} />)}
    </React.Fragment>
  );
}
